/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useOrganisation } from '../../contexts/OrganisationContext';

import MainLayout from '../layouts/Main';
import Page from '../partials/Page';
import AllStories from '../partials/AllStories';
import OrganisationMenubar from '../menubars/Organisation';

import styles from '../../../styles/pages/home.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const HomeOrganisationPage = ({ className }) => {
    const organisation = useOrganisation();
    const { name: organisationName = null } = organisation || {};

    return (
        <MainLayout nav={[]}>
            <Page
                title={<span className="ms-1">{organisationName}</span>}
                sidebar={null}
                menubar={<OrganisationMenubar organisation={organisation} />}
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                <AllStories withSearch />
            </Page>
        </MainLayout>
    );
};

HomeOrganisationPage.propTypes = propTypes;
HomeOrganisationPage.defaultProps = defaultProps;

export default HomeOrganisationPage;
